import { createSelector } from 'reselect';
import {
    get,
    isEqual
} from 'lodash';
import { getEntityByName } from '../appEntities';
import {
    TABLE_UNMOUNT,
    UPDATE_COLUMNS_LOAD,
    UPDATE_COLUMNS_FAILURE,
    COLUMNS_LOAD,
    COLUMNS_FAILURE,
    COLUMNS_SUCCESS,
    UPDATE_DATE_RANGE
} from './tableActions';

export default function reducer(state = { columnsMapper: {} }, action = {}) {
    let newState;

    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                columnsMapper: {}
            };

            return isEqual(state, newState) ? state : newState;

        case UPDATE_COLUMNS_LOAD:
            newState = {
                ...state,
                columnsMapper: {
                    ...state.columnsMapper,
                    [action.uniqueTableName]: {
                        ...state.columnsMapper[action.uniqueTableName],
                        columns: action.columns,
                        sorts: action.sorts
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;

        case UPDATE_COLUMNS_FAILURE:
            newState = {
                ...state,
                columnsMapper: {
                    ...state.columnsMapper,
                    [action.uniqueTableName]: {
                        ...state.columnsMapper[action.uniqueTableName],
                        error: action.error
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;

        case COLUMNS_LOAD:
            newState = {
                ...state,
                columnsMapper: {
                    ...state.columnsMapper,
                    [action.uniqueTableName]: {
                        columns: [],
                        error: null,
                        loading: true,
                        loaded: false,
                        sorts: []
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;

        case COLUMNS_SUCCESS:
            newState = {
                ...state,
                columnsMapper: {
                    ...state.columnsMapper,
                    [action.uniqueTableName]: {
                        ...state.columnsMapper[action.uniqueTableName],
                        columns: action.columns,
                        loading: false,
                        loaded: true,
                        sorts: action.sorts
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;

        case COLUMNS_FAILURE:
            newState = {
                ...state,
                columnsMapper: {
                    ...state.columnsMapper,
                    [action.uniqueTableName]: {
                        ...state.columnsMapper[action.uniqueTableName],
                        columns: action.columns,
                        error: action.error,
                        loading: false,
                        loaded: true,
                        sorts: []
                    }
                }
            };

            return isEqual(state, newState) ? state : newState;

        case UPDATE_DATE_RANGE:
            newState = {
                ...state,
                dateRange: action.dateRange
            };

            return isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getTableEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'table')
);

export const getDateRange = createSelector(
    getTableEntity,
    (entity) => get(entity, 'dateRange')
);

export const getColumnsMapper = createSelector(
    getTableEntity,
    (entity) => get(entity, 'columnsMapper')
);

export const getColumnsObjectByUniqueTableName = createSelector(
    getColumnsMapper,
    (state, uniqiueTableName) => (uniqiueTableName),
    (columnsMapper, uniqiueTableName) => get(columnsMapper, uniqiueTableName)
);

export const getIsColumnsLoadingByUniqueTableName = createSelector(
    (state, id) => getColumnsObjectByUniqueTableName(state, id),
    (entity) => get(entity, 'loading')
);

export const getIsColumnsLoadedByUniqueTableName = createSelector(
    (state, id) => getColumnsObjectByUniqueTableName(state, id),
    (entity) => get(entity, 'loaded')
);

export const getColumnsByUniqueTableName = createSelector(
    (state, id) => getColumnsObjectByUniqueTableName(state, id),
    (entity) => get(entity, 'columns')
);

export const getSortsByUniqueTableName = createSelector(
    (state, id) => getColumnsObjectByUniqueTableName(state, id),
    (entity) => get(entity, 'sorts')
);

export const getColumnsErrorByUniqueTableName = createSelector(
    (state, id) => getColumnsObjectByUniqueTableName(state, id),
    (entity) => get(entity, 'error')
);

export const getColumnsErrorMessageByUniqueTableName = createSelector(
    (state, id) => getColumnsErrorByUniqueTableName(state, id),
    (error) => get(error, 'message')
);
